import React from 'react';

export default function Confirmation({ selectedClients, selectedWorkflow, target, selectedSequential, android, releaseNotes, automaticRelease, skipDeploy }) {
	return (
		<>
			<div>
				Gerar build <strong>{android ? 'Android' : 'iOS'}</strong> a partir de <strong>{target}</strong>,
				{selectedSequential && (
					<>
						{' '}
						com a versão sequencial <strong>{selectedSequential}</strong>,
					</>
				)}{' '}
				{!android && (
					<>
						{' '}
						na worlflow
						<strong> {selectedWorkflow}</strong>,
					</>
				)}
				para o(s) cliente(s) abaixo:
				<br />
				<br />
				<strong>{selectedClients.join(', ').toUpperCase()}</strong>
				{!skipDeploy && releaseNotes && (
					<>
						<br />
						<br />
						<span className="warning">A versão {automaticRelease ? '' : ' NÃO '} será liberada automaticamente após revisão!</span>
						<br />
						<br />
						<strong>
							<span>Notas da versão:</span>
						</strong>
						<span className="preview-release-notes">{releaseNotes}</span>
					</>
				)}
			</div>
		</>
	);
}
